import { render } from "./ImgCredited.vue?vue&type=template&id=14972ce5"
import script from "./ImgCredited.vue?vue&type=script&lang=js"
export * from "./ImgCredited.vue?vue&type=script&lang=js"

import "./ImgCredited.vue?vue&type=style&index=0&id=14972ce5&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__